<template>
  <div class="navi-wrapper" v-if="!audioActive">
    <div class="borderIconPadding"></div>
    <div class="naviInnerContent">
      <div class="left-button">
        <div
          class="naviButton"
          :class="[{ disabled: !prevExist }, { disabled: !nextExist }, { naviElementHide: galleryActive }]"
          @click="drawing"
          v-if="!mbciwdState"
        >
          <!-- <b-tooltip target-id="Rysuj"> -->
          <div :title="getTooltips['rysuj']" class="navi-icon-image">
            <img
              draggable="false"
              src="~@/assets/icons/book/footerNavi/menuRysuj-OFF.png"
              class="icon-off"
              v-show="!canvasActive"
            />
            <img
              draggable="false"
              src="~@/assets/icons/book/footerNavi/menuRysuj-ON.png"
              class="icon-on"
              :class="[{ drawingOpacity: canvasActive }]"
            />
          </div>
          <!-- </b-tooltip> -->
        </div>
        <!-- canvasToolbox -->
        <tr-navi-canvas-toolbox v-if="showCanvasToolbox"></tr-navi-canvas-toolbox>
        <div
          class="naviButton"
          v-if="showBookIndexIcon"
          :class="[{ disabled: isModalImageActive }, { naviElementHide: galleryActive }]"
          @click="bookIndex"
        >
          <!-- <b-tooltip target-id="Spis treści"> -->
          <div class="navi-icon-image" :title="getTooltips['spisTresci']" v-if="!mbciwdState">
            <img draggable="false" src="~@/assets/icons/book/footerNavi/menuSpis-OFF.png" class="icon-off" />
            <img draggable="false" src="~@/assets/icons/book/footerNavi/menuSpis-ON.png" class="icon-on" />
          </div>
          <!-- </b-tooltip> -->
        </div>
      </div>
      <page-navi
        class="naviButtonHeight"
        :class="[{ disabled: isModalImageActive }, { naviElementHide: galleryActive }]"
      >
      </page-navi>
      <div class="right-button">
        <div
          class="zoomInButton naviButton"
          :class="[
            { disabled: !prevExist },
            { disabled: !nextExist },
            { disabled: isMobile },
            { disabled: isModalImageActive },
            { naviElementHide: galleryActive },
          ]"
          @click="zoomIn"
        >
          <!-- <b-tooltip target-id="Powiększ"> -->
          <div class="navi-icon-image zoomInIcon" :title="getTooltips['powieksz']" v-if="!mbciwdState">
            <img
              draggable="false"
              src="~@/assets/icons/book/footerNavi/menuPowieksz-OFF.png"
              class="icon-off"
              v-show="!zoomInActive"
            />
            <img
              draggable="false"
              src="~@/assets/icons/book/footerNavi/menuPowieksz-ON.png"
              class="icon-on"
              :class="{ 'zoom-in-active-class': zoomInActive }"
            />
          </div>
          <!-- </b-tooltip> -->
        </div>
        <div
          v-if="!showElectronOnlyIcons && !mbciwdState"
          @click="fullScreenToogle"
          class="fullScreenButton naviButton"
          :class="[{ disabled: isModalImageActive }, { disabled: isMobile }, { naviElementHide: galleryActive }]"
        >
          <!-- <b-tooltip target-id="Pełny ekran"> -->
          <div class="navi-icon-image" :title="getTooltips['fullScreen']">
            <img
              draggable="false"
              src="~@/assets/icons/book/footerNavi/menuPelny-OFF.png"
              class="icon-off"
              v-show="!fullScreenActive"
            />
            <img
              draggable="false"
              src="~@/assets/icons/book/footerNavi/menuPelny-ON.png"
              class="icon-on"
              :class="{ fullScreenActiveClass: fullScreenActive }"
            />
          </div>
          <!-- </b-tooltip> -->
        </div>
      </div>
    </div>
    <div class="borderIconPadding"></div>
  </div>
</template>

<script>
import TrNaviCanvasToolbox from './SubComponents/TrNaviCanvasToolbox';
import PageNavi from './PageNavi/PageNavi';
export default {
  name: 'footer-navi',
  props: [],
  data: function () {
    return {
      canvasPaint: false,
    };
  },
  components: {
    TrNaviCanvasToolbox,
    PageNavi,
  },
  methods: {
    fullScreenToogle() {
      if (!this.$store.getters.isWeb) {
        if (!this.fullScreenActive) {
          this.$store.commit('TOGGLE_FULL_SCREEN_ACTIVE', true);
          this.$electron.remote.getCurrentWindow().setFullScreen(true);
        } else {
          this.$store.commit('TOGGLE_FULL_SCREEN_ACTIVE', false);
          this.$electron.remote.getCurrentWindow().setFullScreen(false);
        }
      } else {
        console.log('WEB FULLSCREEN');
      }
    },
    pageControl() {
      return this.pageControl;
    },
    drawing() {
      // this.$store.commit( 'TOGGLE_CANVAS_ACTIVE', this.canvasActive );
      this.$store.commit('TOGGLE_CANVAS');
      this.$store.commit('TOGGLE_CANVAS_TOOLBOX');
      console.log(' this.textMarkerCanvasActive', this.textMarkerCanvasActive);
      if (this.textMarkerCanvasActive) {
        this.$store.commit('TOGGLE_CANVAS_TEXT_MARKER', false);
      }
      this.$store.commit('TOGGLE_UI_DISABLE', !this.allTopLayoutDisable);
    },
    zoomIn() {
      this.$store.commit('TOGGLE_UI_DISABLE', !this.allTopLayoutDisable);
      this.$store.commit('ZOOMIN_ACTIVE', !this.zoomInActive);
    },
    bookIndex() {
      this.$store.commit('SHOW_BOOK_INDEX', !this.showBookIndex);
      this.$store.commit('BOOK_INDEX_ACTIVE', !this.bookIndexActive);
    },
    mobileAndTabletcheck() {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
  },
  computed: {
    mbciwdState() {
      return this.$store.getters.mbciwdActive;
    },
    correctModuleName() {
      let name = this.$store.getters.multibookType;
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name;
    },
    allTopLayoutDisable() {
      return this.$store.getters.allTopLayoutDisable;
    },
    canvasActive() {
      return this.$store.getters.canvasActive;
    },
    zoomInActive() {
      return this.$store.getters.zoomInActive;
    },
    fullScreenActive() {
      return this.$store.getters.fullScreenActive;
    },
    showBookIndex() {
      return this.$store.getters.showBookIndex;
    },
    bookIndexActive() {
      return this.$store.getters.bookIndexActive;
    },
    showBookIndexIcon() {
      return this.$store.getters[`${this.correctModuleName}/showBookIndexIcon`];
    },
    nextExist() {
      return this.$store.getters[`${this.correctModuleName}/nextExist`];
    },
    prevExist() {
      return this.$store.getters[`${this.correctModuleName}/prevExist`];
    },
    isModalImageActive() {
      return this.$store.getters.isModalImageActive;
    },
    bookIndexDisable() {
      return this.$store.getters.bookIndexDisable;
    },
    showCanvasToolbox() {
      return this.$store.getters.showCanvasToolbox;
    },
    galleryActive() {
      return this.$store.getters.galleryActive;
    },
    audioActive() {
      return this.$store.getters.audioActive;
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
    textMarkerCanvasActive() {
      return this.$store.getters.textMarkerCanvasActive;
    },
    isMobile() {
      return this.mobileAndTabletcheck();
    },
    showElectronOnlyIcons() {
      return this.$store.getters.isWeb;
    },
    showZoomIn() {
      return this.$store.getters.showZoomIn;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';

.left-button,
.right-button {
  display: flex;
}
.left-button {
  .navi-icon-image {
    margin-right: 20px;
  }
}
.right-button {
  .navi-icon-image {
    margin-left: 20px;
  }
}
.navi-wrapper {
  overflow: hidden;
  background-color: $mainColor;
  z-index: 300;
  display: flex;
  flex-direction: row;
  margin-left: auto;
  margin-right: auto;
  .borderIconPadding {
    width: $borderIconPadding;
  }
  .naviInnerContent {
    width: 100%;
    height: $naviWrapperHeight;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .naviButton {
      display: flex;
      justify-content: center;
      align-items: center;
      // height: 100%;
    }
  }
}
.image-wrapper {
  .navi-wrapper {
    width: 100%;
    height: $naviWrapperHeight;
    margin: 0;
  }
}
.naviText {
  font-size: initial;
  @media screen and (max-height: 720px) {
    font-size: xx-small;
  }
  @media screen and (min-height: 721px) and (max-height: 1079px) {
    font-size: small;
  }
}
.navi-icon-image {
  width: $naviIconImageWidth;
  height: $naviIconImageHeight;
  position: relative;
  visibility: visible;
  opacity: 1;
  cursor: pointer;
  // transition: visibility 0s, opacity 0.3s ease-in;
}

.navi-icon-image .icon-off {
  width: 100%;
  height: 100%;
  visibility: visible;
  opacity: 1;
  position: absolute;
  top: 0;
  left: 0;
  // z-index: 99;
  transition: visibility 0s, opacity 0.5s ease-out;
}
.navi-icon-image .icon-on {
  // display: none;
  width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  // z-index: 99;
  transition: visibility 0s, opacity 0.5s ease-out;
}
.navi-icon-image:hover .icon-on {
  // display: inline;
  visibility: visible;
  opacity: 1;
  // transition: visibility 0s, opacity 0.3s ease-in;
}
.zoom-in-active-class {
  width: 100%;
  height: 100%;
  visibility: visible !important;
  opacity: 1 !important;
  position: absolute;
  top: 0;
  left: 0;
  // z-index: 99;
}
.fullScreenActiveClass {
  visibility: visible !important;
  opacity: 1 !important;
}
.uiDisableClass {
  display: none;
}
.drawingOpacity {
  opacity: 1 !important;
  visibility: visible !important;
}
.disabled {
  opacity: 0;
  pointer-events: none;
}
</style>
